import React, { Component } from 'react';
import { Modal, Row, Col, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import CardLessDataTableWithSearch from '../../datatables/CardLessDataTableWithSearch';

const FETCH_ADAPTIVE_EXAMS_STUDENT = gql`
  query($exam_id:Int!){
                        getAdaptiveExamsForAStudent(exam_id:$exam_id){
    correct
    wrong
    not_answered
    total_questions
    score
    accuracy
    exam_paper_id
    exam_name
    exam_id
    mobile
    class
       attempts {
      correct
      wrong
      not_answered
      exams
      avg_score
      avg_accuracy
    }
                        }
                    }  
`;


class StudentAdaptiveExamReportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    };

    columns = [
        {
            dataField: "index",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
            align: "center",
            headerClasses: "text-center",
        },
        {
            dataField: "exam_name",
            text: "Exam Name",
            sort: true,
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "class",
            text: "Class",
            sort: true,
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "correct",
            text: "Correct",
            sort: true,
            align: "center",
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "wrong",
            text: "Wrong",
            sort: true,
            align: "center",
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "not_answered",
            text: "Not Answered",
            sort: true,
            align: "center",
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "total_questions",
            text: "Total Questions",
            sort: true,
            align: "center",
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "score",
            text: "Score",
            sort: true,
            align: "center",
            formatter: (cell) => cell ? `${cell}` : "-",
        },
        {
            dataField: "accuracy",
            text: "Accuracy (%)",
            sort: true,
            align: "center",
            formatter: (cell) => cell ? `${cell}%` : "0%",
        },
        {
            dataField: "mobile",
            text: "Mobile",
            sort: true,
            formatter: (cell) => cell ? `${cell}` : "-",
        }
    ];

    render() {
        const adaptiveExamStudentData = this.props.getAdaptiveExamsForAStudent;
        const loading1 = adaptiveExamStudentData.loading;
        const error1 = adaptiveExamStudentData.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        return (
            <Modal {...this.props} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">View Report</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{
                    width: '100%',
                    height: '300px',
                    overflow: 'auto',
                }}>
                    <Container fluid>
                        {loading1 ? (
                            <Container>
                                <Row className="my-3">
                                    <Col>
                                        <div className="spinner-border text-primary text-center loading-img-center"></div>
                                    </Col>
                                </Row>
                            </Container>
                        ) : (
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12}>
                                    {
                                        adaptiveExamStudentData.getAdaptiveExamsForAStudent !== null ? (
                                            <CardLessDataTableWithSearch
                                                parentData={adaptiveExamStudentData.getAdaptiveExamsForAStudent ? [adaptiveExamStudentData.getAdaptiveExamsForAStudent] : []}
                                                particlecolumns={this.columns}
                                                name="hostel_attendance"
                                            />    
                                        ) : (
                                            <div className="d-flex justify-content-center">
                                                <h6>No Data Found</h6>
                                            </div>
                                        )
                                    }
                                </Col>
                            </Row>
                        )}
                    </Container>
                </Modal.Body >
            </Modal >
        );
    }
}

export default withRouter(
    compose(
        graphql(FETCH_ADAPTIVE_EXAMS_STUDENT, {
            options: (props) => ({
                variables: {
                    exam_id: parseInt(props.stateData?.selectedExamValue?.value) || 0
                },
                fetchPolicy: "network-only"
            }),
            name: "getAdaptiveExamsForAStudent"
        })
    )(StudentAdaptiveExamReportModal)
);
